import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
});

const RenderCheckField = ({
  input, label, valueType, classes, meta: { touched, error }, ...custom // eslint-disable-line
}) => {
  // const defaultProps = {};
  // const value = (input.value || 0).toString();
  // if (valueType === 'number') {
  //   defaultProps.onChange = (event, checked) => {
  //     input.onChange(checked ? 1 : 0);
  //   };
  //   defaultProps.onBlur = (event) => {
  //     input.onChange(event.target.checked ? 1 : 0);
  //   };
  // }
  return (
    <FormControlLabel
      label={label}
      classes={classes}
      control={(
        <Checkbox
          // checked={input.value === 1}
          checked={!!input.value}
          // error={!!touched && !!error}
          {...input}
          {...custom}
          // {...defaultProps}
          value
          color="primary"
        />
      )}
    />
  );
};

export { Checkbox };

export default withStyles(styles)(RenderCheckField);
